import { ApplicationState } from '../index';
import {} from './Reducer';
import { 
    PortalTextLogin,
    PortalTextSectionIds,
} from '../../Models/Api/strongbox.financialportal';

export function GetPortalLoginText(state: ApplicationState): PortalTextLogin | undefined {
    if (!(state && state.portalAssets)) {
        return undefined;
    }
    const loginText = state.portalAssets.textSections.get('loginPage');
    if (!loginText) {
        return undefined;
    }

    return loginText as PortalTextLogin;
}

export function GetPortalText<T>(state: ApplicationState, sectionId: PortalTextSectionIds ): T | undefined {
    if (!(state && state.portalAssets)) {
        return undefined;
    }
    const text = state.portalAssets.textSections.get(sectionId);
    if (!text) {
        return undefined;
    }

    return text as T;
}

export function GetPortalLanguage(state: ApplicationState): string {
    if (!(state && state.portalAssets)) {
        return 'en';
    }
    const result = `${state.portalAssets.languageCode}${!!state.portalAssets.localeCode ? `-${state.portalAssets.localeCode}` : ''}`;
    return result;
}

/// Get only the language code portion of the portal language, i.e. "en" if the full language
/// spec is "en-us"
export function GetPortalLanguageCode(state: ApplicationState): string {
    if (!(state && state.portalAssets)) {
        return 'en';
    }
    return state.portalAssets.languageCode;
}
